module.exports = __webpack_public_path__ + "img/pic_new_features_1.b6a9cc0c.png";